import React from "react";
import "./about.css";
import CountUp from "react-count-to";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import MediaQuery from "react-responsive";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";

export class about extends React.Component {
  constructor(args) {
    super(args);
    this.state = {};
    this.tabContent = [
      {
        id: 0,
        title: "About ProClub",
      },
      {
        id: 1,
        title: "Winpe",
      },
      {
        id: 2,
        title: "Sheffield Haworth",
      },
      
    ];
    this.quotesContent = [
      {
        id: 0,
        title: "mentor",
        title1: "mondays",
        text:
          "The best way to get your point across is to first state your facts, then express your emotions, and then do the interpretation.",
        name: "Arvind Thakur",
        post: " Member, Board of Management,",
        postt: `<div>NIIT University</div>`,
      },
      {
        id: 1,
        title: "mentor",
        title1: "mondays",
        text:
          "If something is not going your way, think of what you can learn from it. Use it to think of how you can pivot to a new strategy.",
        name: "Ester Martinez",
        post: "CEO & Editor in Chief,",
        postt: `<div>People Matters</div>`,
      },
      {
        id: 2,
        title: "mentor",
        title1: "mondays",
        text:
          "Don’t expect the world to endorse you when you start out. It is your journey, and the lack of endorsements should not deter you from your goals and plans.",
        name: "Renuka Ramnath",
        post: "Founder, MD & CEO,",
        postt: `<div>Multiples Alternate Asset Management <br /> & Member, Advisory Board, Winpe</div>`,
      },
    ];
  }
  render() {
    let settings = {
      dots: false,
      infinite: true,
      speed: 1,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplaySpeed: 300,
      arrows: true,
      centerMode: true,
    };
    this.render1 = this.render1 + 1;
    return (
      <div className="section__content">
        <div className="aboutSection__wrapper" id="about">
          <div className="aboutSection__content">
            <div className="aboutSection__section">
              <div className="top_section">
                <div className="tab_section">
                  <Tabs>
                    <TabList>
                      <Tab>
                        <spam>About ProClub</spam>&nbsp;&nbsp;
                      </Tab>
                      |
                      <Tab>
                        <spam>Winpe</spam>&nbsp;&nbsp;
                      </Tab>
                         |
                       <Tab>
                        <spam>Sheffield Haworth</spam>&nbsp;&nbsp;
                      </Tab>
                    </TabList>
                    <TabPanel>
                      <div className="about_right_section">
                        <div className="right_section_content">
                          <div className="section_text">
                            Mentorship has been acknowledged as one of the most
                            powerful tools driving professional success. In the
                            case of women, mentorship can be a key success
                            factor as women deal with workplaces largely
                            dominated by men. The Winpe ProClub Mentorship
                            Program is a pioneering initiative that aims to
                            accelerate career growth for high performing women
                            from the investing ecosystem by connecting them with
                            industry leaders for 1:1 mentoring over a period of
                            twelve months. Winpe believes that this initiative
                            will help create a deep pipeline of female leaders
                            for the industry, facilitating a much-required
                            gender balance in leadership positions and shaping
                            the future course of the industry. Winpe brings in best practices
                            in designing, implementing and administering the
                            mentorship program, with a view to maximizing the
                            value and outcomes for all stakeholders.
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="about_right_section">
                        <div className="right_section_content">
                          <div className="section_text">
                          Winpe is a not-for-profit established with the
                            objective of enhancing gender diversity within the
                            investing ecosystem, increasing the participation of
                            women as investors, capital allocators and
                            recipients of investment capital. Winpe has been set
                            up as the catalytic platform to drive sensitization,
                            awareness and positive action among firms in the
                            investing ecosystem in favor of gender diversity,
                            while also providing a set of resources for women to
                            leverage in crafting fulfilling professional
                            journeys. Winpe believes that the combination of
                            efforts to bring about a positive change in the
                            working environment, coupled with a conscious
                            nurturing of female talent within the ecosystem will
                            lead to a tangible enhancement in diversity
                            statistics over a period of time.
                          </div>
                          <div className="link_section">
                            <span>
                              <a
                                href="https://winpeforum.com/home/"
                                target="_blank"
                              >
                                Visit the Winpe Website
                              </a>
                              &nbsp;&nbsp; |
                            </span>
                            <span>
                              <a
                                href="https://winpeforum.com/events/"
                                target="_blank"
                              >
                                {" "}
                                View upcoming Winpe Events
                              </a>
                            </span>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="about_right_section">
                        <div className="right_section_content">
                          <div className="section_text">
                         Sheffield Haworth is a global consultancy specializing in executive search, change consulting,
and strategic advisory. Founded in 1993, the firm has grown to more than 200 professionals
across 14 offices worldwide, partnering with clients to deliver people-led transformation for the
financial services, professional services, and private equity industries, as well as their portfolio
companies.
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
                {/*<div className="count_section">
                                    <div className="count_content">
                                        <div className="rview_text_box">
                                            <div className="row">
                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                    <div className="rview_text">
                                                        <div className="c_img">
                                                            <img src="https://winpeforum.com/assets/elements/Microsite_Analytics_Band_03_1.png" alt="" />
                                                        </div>
                                                        <span>
                                                            <CountUp from={1} to={283441} speed={1000 * 3 } />++
                                                        </span><br /> Impressions 
                                                    </div>
                                                    <div className="right_border_section"></div>
                                                </div>
                                                <div className="col-md-6 col-sm-6 col-xs-6">
                                                    <div className="rview_text">
                                                        <div className="c_img">
                                                            <img src="https://winpeforum.com/assets/elements/Microsite_Analytics_Band_05_1.png" alt="" />
                                                        </div>
                                                        <span>
                                                            <CountUp from={110} to={17276} speed={500 * 5} />++
                                                        </span> <br /> Original Content Reach 
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                <div className="quotes_section">
                  <div className="quotes_content">
                    <div className="q_heading">
                      <h1>
                        <span style={{ color: "#BF2026" }}>Quotable</span>{" "}
                        Quotes
                      </h1>
                    </div>
                    <div className="row">
                      <div className="" style={{ padding: "20px 0 30px" }}>
                        <div className="row">
                          <Slider {...settings}>
                            {this.quotesContent.map((item, i) => {
                              return (
                                <div className="tes-card">
                                  <div className="top-section">
                                    <spam>
                                      <i
                                        className="fa fa-quote-left"
                                        aria-hidden="true"
                                      ></i>
                                    </spam>
                                    <p>{item.text}</p>
                                    <spam>
                                      <i
                                        className="fa fa-quote-right"
                                        aria-hidden="true"
                                      ></i>
                                    </spam>
                                    <div className="name">{item.name}</div>
                                    <div className="post">{item.post}</div>
                                    <div className="postt">
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: item.postt,
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </Slider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default about;



// WEBPACK FOOTER //
// ./src/components/about/index.jsx